import React from "react";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

interface Props {
  label?: string;
  optionsType?: any;
  error?: boolean;
  helperText?: any;
  selectedOption?: string;
  handleChange?: (v: string) => void;
  getOptionLabel?: (option: any) => any;
  renderOption?: (option: any) => any;
  groupBy?: (option: any) => any;
  renderGroup?: (option: any) => any;
  required?: boolean;
  name?: string;
  value?: any;
  loading?: boolean;
  disableClearable?: any;
  onChange?: (v: any) => void;
  onKeyUp?: (v: any) => void;
  placeholder?: any;
  InputProps?: any;
  disabled?: any;
  cssClassName?: string;
  onKeyDownCapture?: (v: any) => void;
  onPaste?: (v: any) => void;
}

export default function CommonAutoCompleteField({
  label = "Add Label",
  optionsType,
  error,
  handleChange,
  getOptionLabel,
  groupBy,
  renderOption,
  renderGroup,
  required = false,
  name = "",
  value = null,
  loading = false,
  disableClearable = false,
  helperText,
  onChange,
  onKeyUp,
  placeholder,
  InputProps,
  disabled,
  cssClassName,
  onKeyDownCapture,
  onPaste,
}: Props) {
  return (
    <Autocomplete
      disabled={disabled}
      id={name}
      size="small"
      fullWidth
      loading={loading}
      options={optionsType || []}
      disableClearable={disableClearable}
      value={value}
      onInputChange={(_e, v) => {
        handleChange && handleChange(v);
      }}
      onChange={(e, v) => onChange && onChange(v)}
      onKeyUp={(e) => onKeyUp && onKeyUp(e)}
      getOptionLabel={(option) => getOptionLabel && getOptionLabel(option)}
      renderOption={(option) =>
        (renderOption && renderOption(option)) || (getOptionLabel && getOptionLabel(option))
      }
      groupBy={groupBy ? (option) => groupBy && groupBy(option) : undefined}
      renderGroup={renderGroup ? (option) => renderGroup && renderGroup(option) : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          className={cssClassName}
          required={required}
          error={error}
          helperText={helperText}
          id={name}
          label={label}
          name={name}
          variant="outlined"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          fullWidth
          placeholder={placeholder}
          onKeyDownCapture={(e) => onKeyDownCapture && onKeyDownCapture(e)}
          onPaste={(e) => onPaste && onPaste(e)}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {InputProps}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
